/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: calc(12rem /14);
  display: block;
  height: calc(18rem /14);
  position: relative;
}
:host .scroll-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

:host([hidden]) {
  display: none;
}`;
export { style };
